export const missionEditTabPath = (missionId: string, tab: string) =>
  `/main/dashboard/mission/edit/${missionId}/${tab}`;

export const missionCompletePath = (missionId: string, tab: string, reason: string) =>
  `${missionEditTabPath(missionId, tab)}/complete-mission/${reason}`;
